import { ImpactType } from '../../impact/units';
import { CawTier } from './tiers';

export type ImpactValues<T = number> = Record<ImpactType, T>;

// The proportion of the customer's payment that is allocated to each impact type
export const subscriptionImpactFundAllocation: Record<CawTier, ImpactValues> = {
  [CawTier.SEED]: {
    [ImpactType.TREES]: 0.51,
    [ImpactType.CARBON_OFFSETS]: 0.49,
    [ImpactType.HABITAT_RESTORATION]: 0,
    [ImpactType.CARBON_REMOVAL]: 0,
  },
  [CawTier.GROW]: {
    [ImpactType.TREES]: 0.33,
    [ImpactType.CARBON_OFFSETS]: 0.23,
    [ImpactType.HABITAT_RESTORATION]: 0.44,
    [ImpactType.CARBON_REMOVAL]: 0,
  },
  [CawTier.BLOOM]: {
    [ImpactType.TREES]: 0.29,
    [ImpactType.CARBON_OFFSETS]: 0.14,
    [ImpactType.HABITAT_RESTORATION]: 0.38,
    [ImpactType.CARBON_REMOVAL]: 0.19,
  },
};

export const impactQuantities: Record<CawTier, ImpactValues> = {
  [CawTier.SEED]: {
    [ImpactType.TREES]: 3,
    [ImpactType.CARBON_OFFSETS]: 0.5,
    [ImpactType.HABITAT_RESTORATION]: 0,
    [ImpactType.CARBON_REMOVAL]: 0,
  },
  [CawTier.GROW]: {
    [ImpactType.TREES]: 6,
    [ImpactType.CARBON_OFFSETS]: 0.75,
    [ImpactType.HABITAT_RESTORATION]: 0.5,
    [ImpactType.CARBON_REMOVAL]: 0,
  },
  [CawTier.BLOOM]: {
    [ImpactType.TREES]: 12,
    [ImpactType.CARBON_OFFSETS]: 1,
    [ImpactType.HABITAT_RESTORATION]: 1,
    [ImpactType.CARBON_REMOVAL]: 0.1,
  },
};
